.card {
  padding: var(--sp-6);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
}
